import { render, staticRenderFns } from "./medicineType.vue?vue&type=template&id=73d89dd6&"
import script from "./medicineType.vue?vue&type=script&lang=js&"
export * from "./medicineType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports